import { useParams } from "react-router-dom";
import ServiceDetail from "@/components/ServiceDetail";
import NotFound from "@/pages/NotFound";
import { COMMERCIAL_SERVICES_DATA } from "@/data/commercial-services";

export default function CommercialServiceDetail() {
    const { service } = useParams();
    const data = COMMERCIAL_SERVICES_DATA[service];
    if (!data) return <NotFound />;
    return <ServiceDetail data={data} track="commercial" />;
}
